/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import * as styles from './ActionText.module.scss';

function ActionText({
  onClick,
  title,
  style = {},
  type,
  disabled,
  target,
  renderComponent: Component = 'button',
}) {
  const commonProps = {
    className: cn(
      styles.actionText,
      {
        [styles.typeBlack]: type === 'black',
        [styles.typeBold]: type === 'bold',
      },
    ),
    onClick,
    style,
    disabled,
  };

  if (target) {
    return (
      <a
        href={target}
        target="_blank"
        {...commonProps}
        style={{ ...style, textDecoration: 'none' }}
        rel="noreferrer"
      >
        {title}
      </a>
    );
  }

  return (
    <Component
      {...commonProps}
      type={Component === 'button' ? 'button' : undefined}
    >
      {title}
    </Component>
  );
}

ActionText.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  target: PropTypes.string,
  renderComponent: PropTypes.elementType,
};

export default ActionText;